module.exports = __webpack_public_path__ + "bw.b708b280fd42f200acaa.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bw.svg
// module chunks = styles